export const GOALTYPES = {
    MINUTES: "minutes",
    CALORIES: "calories",
};

export const FEEDBACK_ICONS = {
    THUMBS_UP: "ThumbsUp",
    THUMBS_DOWN: "ThumbsDown",
    NONE: "",
};

export const FEEDBACK_MESSAGES = {
    USER_STILL: "UserStill",
};

export const FEEDBACK_STICKER_INTERVAL = 10;
export const FEEDBACK_STICKER_ENABLED =
    process.env.VUE_APP_STICKERS_ENABLED == "true" ||
    process.env.VUE_APP_STICKERS_ENABLED == true;
export const STICKERS_INTERVAL_TIME =
    process.env.VUE_STICKER_SHOW_TIME_IN_MILLISECOND ?? 10000;
export const UP_STICKER_ACCURACY_INCREASE_DIFFERENCE = 5;
export const DOWN_STICKER_ACCURACY_DECREASE_DIFFERENCE = -10;

export const HIDE_CHANNELS = ["HPB", "EliteFit"]
export const MOVE_CHANNELS_BOTTOM = ["Boss Girls", "Elitefit Mix"]

export const USE_MOBILE_WORKOUT_UI =
    process.env.VUE_APP_USE_MOBILE_WORKOUT_UI === 'true' ||
    process.env.VUE_APP_USE_MOBILE_WORKOUT_UI === true;

export const USE_DESKTOP_WORKOUT_UI =
    process.env.VUE_APP_USE_NEW_DESKTOP_UI === 'true' || process.env.VUE_APP_USE_NEW_DESKTOP_UI === true;